import { PhotosClearSelectedPhotosReducer } from './types';

export const photosClearSelectedPhotosReducer: PhotosClearSelectedPhotosReducer =
  (state) => {
    return {
      ...state,
      selectedPhotos: [],
    };
  };
